'use strict';
angular.module('common.filters').filter('decodeUri', function () {
  'use strict';
  return function (string) {
    return decodeURIComponent(string);
  };
});
